export const navBarStyle = {
  errorStyle: {
    color: 'error.main',
  },
  defaultStyle: {
    color: 'text.secondary',
  },
} as const;
